import { render, staticRenderFns } from "./VerifySafte.vue?vue&type=template&id=2a0ad206&"
import script from "./VerifySafte.vue?vue&type=script&lang=js&"
export * from "./VerifySafte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports